import { isEmpty } from 'lodash';
import { isVideoOutput } from '../../../cross-team-shared/misc-utils/output-utils';
import {
  getProjectionType,
  ProjectionType,
} from '../../../cross-team-shared/misc-utils/projection-utils';
import { getOrThrow } from '../../../cross-team-shared/misc-utils/strict-record';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { AbstractProjectionUtils } from './abstract-projection-utils';
import { BrownConradyProjectionUtils } from './brown-conrady-projection-utils';
import { CdiCylindricalProjectionUtils } from './cdi-cylindrical-projection-utils';
import { CdiDeformedCylinderProjectionUtils } from './cdi-deformed-cylinder-projection-utils';
import { CdiLutProjectionUtils } from './cdi-lut-projection-utils';
import { PinholeProjectionUtils } from './pinhole-projection-utils';

export const projectionUtils: StrictRecord<
  Exclude<ProjectionType, 'kannala_brandt'>,
  AbstractProjectionUtils
> = {
  pinhole: new PinholeProjectionUtils(),
  lut: new CdiLutProjectionUtils(),
  cylinder: new CdiCylindricalProjectionUtils(),
  deformed_cylindrical: new CdiDeformedCylinderProjectionUtils(),
  brown_conrady: new BrownConradyProjectionUtils(),
};

export function shouldCurveEdges(state: PointCloudContentState) {
  const videoOutputs = state.project.outputs.filter(
    (o) => isVideoOutput(o) && !o.meta.is_orthographic_projection,
  );

  // without calibration data, the projection layer is not placed
  if (isEmpty(state.calibrationData) || isEmpty(videoOutputs)) {
    return false;
  }

  return videoOutputs.some((output) => {
    const projectionType = getProjectionType(
      state.calibrationData[output.name],
      state.task,
      output.name,
    );

    return projectionType !== 'pinhole';
  });
}

export function getProjectionUtils(projectionType: ProjectionType) {
  if (projectionType === 'kannala_brandt') {
    throw new Error(`Unsupported projection type: ${projectionType}`);
  }
  return getOrThrow(projectionUtils, projectionType);
}
